import { t } from '../i18n/idioma';
import { ehAvisoDeEvento, Realce, type RealceFaixa } from './regras';

const ADMIN_AVISO = 114;
const ADMIN_EVENTO = 115;
const ADMIN_MANUTENCAO = 116;
const EVENTO_PORTAL = 106;
const EVENTO_ABERTO = 109;
const EVENTO_ESTORNO = 110;
const MUNDO_PUBLICADO = 117;

export function pecasDoAviso(
  code: number,
  args: readonly string[],
  realce: RealceFaixa,
  texto: string
): { rotulo: string; texto: string; icone: string } {
  if (code === ADMIN_AVISO) {
    return { rotulo: t('aviso.rotulo.aviso'), texto: args[0] ?? texto, icone: 'aviso' };
  }
  if (code === ADMIN_EVENTO) {
    return { rotulo: t('aviso.rotulo.evento'), texto: args[0] ?? texto, icone: 'evento' };
  }
  if (code === ADMIN_MANUTENCAO) {
    return { rotulo: t('aviso.rotulo.manutencao'), texto: args[0] ?? texto, icone: 'manutencao' };
  }
  if (code === EVENTO_ABERTO) {
    return { rotulo: t('evento.selo.titulo'), texto, icone: 'evento' };
  }
  if (code === EVENTO_PORTAL || code === EVENTO_ESTORNO) {
    return { rotulo: t('evento.selo.titulo'), texto, icone: 'nota' };
  }
  if (code === MUNDO_PUBLICADO) {
    return { rotulo: t('aviso.rotulo.mundo'), texto, icone: 'aviso' };
  }
  if (ehAvisoDeEvento(code)) {
    return { rotulo: t('aviso.rotulo.eventoJogo'), texto, icone: 'evento' };
  }
  const icone = realce === Realce.Urgente ? 'manutencao' : realce === Realce.Nota ? 'nota' : 'aviso';
  const rotulo = realce === Realce.Urgente
    ? t('aviso.rotulo.urgente')
    : realce === Realce.Nota
      ? t('aviso.rotulo.nota')
      : t('aviso.rotulo.aviso');
  return { rotulo, texto, icone };
}
